// Created By JasonNing on 2018/7/13

//引入常量
import {apiConfig} from './apiConfig'

let tools = {
    _CMShost: "//cms.hexfuture.net/",//cms地址头
    _NewCms: "//dcms.hexfuture.net", // 新cms地址
    _exerciseocr: "//exerciseocr.hexfuture.net/", //习题ocr接口地址
    _exerciseInput: "//entryexe.hexfuture.net/", //习题ocr录题地址
    _exerciseInput_arts: "//artsentryexe.hexfuture.net/", //习题ocr录题地址文科
    // _exerciseInput_arts: "//cp.hexfuture.net/", //习题ocr录题地址文科
    _Editor: "//EditorStyle.hexfuture.net/",
    _typesetServer: "//typesetserver2.hexfuture.net/",//latex公式
    _newEditor: 'https://www.hexfuture.net/editor/',//新编辑

    //任务类型
    taskType: ["未转码", "转码失败", "转码完成", "审核中", "审核完成", "纠错中", "纠错完成"],
    //状态码
    status: ["未处理", "处理中", "下载失败", "转码失败", "修改预览地址失败", "已完成", "", "", "审核中", "审核完成", "纠错中", "纠错完成"],

    /**
     * 获取视窗高
     */
    getWinHeight: function () {
        return document.documentElement.clientHeight;
    },

    /**
     * 获取视窗高
     */
    getWinWidth: function () {
        return document.documentElement.clientWidth;
    },

    /**
     *  设置 cookie
     * @param name key值
     * @param value 设置值
     */
    setCookie: function (name, value) {
        let href = window.location.href.substr(8);
        // let domain = href.substr(href.indexOf('.'), href.indexOf('/') - href.indexOf('.'));
        let domain = '.hexfuture.net'

        //如果本地调试
        if (location.href.indexOf("localhost") > 0) {
            domain = "localhost";
        }

        //设置 session
        if ('localtoken NowCourseId UserId userID isTeacher usertoken userName isUserQrcode avatar'.indexOf(name) >= 0) {
            document.cookie = name + "=" + value + ";domain=" + domain + ";path=/;expires=";
        } else {
            let exdate = new Date();
            let expireDays = 365 * 3;
            exdate.setDate(exdate.getDate() + expireDays);
            document.cookie = name + "=" + value + ";domain=" + domain + ";path=/;expires=" + exdate.toGMTString();
        }
    },

    /**
     *  设置 cookie
     * @param name key值
     * @param value 设置值
     */
     setCookie2: function (name, value) {
        let href = window.location.href.substr(8);
        // let domain = href.substr(href.indexOf('.'), href.indexOf('/') - href.indexOf('.'));
        let domain = '.hexfuture.net'

        //如果本地调试
        if (location.href.indexOf("localhost") > 0) {
            domain = "localhost";
        }

        //设置 session
        if ('localtoken NowCourseId UserId userID isTeacher usertoken userName isUserQrcode avatar'.indexOf(name) >= 0) {
            document.cookie = name + "=" + value + ";domain=" + domain + ";path=/;expires=";
        } else {
            let exdate = new Date();
            let expireDays = 365 * 3;
            exdate.setDate(exdate.getDate() + expireDays);
            document.cookie = name + "=" + value + ";domain=" + domain + ";path=/;expires=";
        }
    },

    /**
     * 获取 cookie
     * @param name key值
     * @returns {*} 设置值
     */
    getCookie: function(name) {
        let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return decodeURIComponent(arr[2]);
        else
            return null;
    },

    /**
     * 删除 cookie
     * @param name
     */
     deleteCookie: function (name) {
        let exp = new Date();
        exp.setTime(exp.getTime() - 1);
        let cval = tools.getCookie(name);
        let href = window.location.href.substr(8);
        let domain;
        if (cval != null) {
            //如果本地调试
            if (location.href.indexOf("localhost") > 0) {
                domain = "localhost";
            } else {
                domain = href.substr(href.indexOf('.'), href.indexOf('/') - href.indexOf('.'));
            }
        }
        document.cookie = name + "=" + cval + ";domain=" + domain + ";path=/;expires=" + exp.toGMTString();
    },

     /**
     * 特定删除 cookie
     * @param name
     */
      deleteCookie2: function (name) {
        let exp = new Date();
        exp.setTime(exp.getTime() - 1);

        let href = window.location.href.substr(8);
        let domain;
        //如果本地调试
        if (location.href.indexOf("localhost") > 0) {
            domain = "localhost";
        } else {
            domain = href.substr(href.indexOf('.'), href.indexOf('/') - href.indexOf('.'));
        }
        document.cookie = name + "=;domain=" + domain + ";path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    },

    /**
     * ajax请求方法
     * @param myUrl API地址
     * @param myMethod POST OR GET
     * @param myData 参数
     * @param successFunc 成功方法
     * @param errorFunc 失败方法
     */
    ajaxRequest: function (myUrl, myMethod, myData, successFunc, errorFunc) {
        if (myMethod.toUpperCase() === 'POST') {
            $.ajax({
                url: myUrl,
                method: myMethod,
                data: JSON.stringify(myData),
                contentType: "application/json; charset=utf-8",
                complete: function (XMLHttpRequest) {
                    completeF(XMLHttpRequest);
                },
            });
        } else {
            $.ajax({
                url: myUrl,
                method: myMethod,
                data: myData,
                complete: function (XMLHttpRequest) {
                    completeF(XMLHttpRequest);
                },
            });
        }

        function errorF() {
            if (arguments[0]) {
                $('body').append('<div class="hex-network-error"><span class="haveFont">' + arguments[0] + '</span></div>');
            } else {
                $('body').append('<div class="hex-network-error"><span></span></div>');
            }
            setTimeout(() => {
                $('div.hex-network-error').remove();
            }, 3000);
            if (typeof errorFunc === "function")
                errorFunc();
        }

        function completeF(XMLHttpRequest) {
            let data = '';
            if (XMLHttpRequest.responseJSON === undefined) {
                data = XMLHttpRequest.responseText;
            } else {
                data = XMLHttpRequest.responseJSON;
            }
            //接口请求链路断
            if (XMLHttpRequest.status === 401) {
                tools.api(
                    'user.loginOut',
                    {},
                    tools.deleteCookie('localtoken'),
                    tools.deleteCookie('ssotoken'),
                    tools.deleteCookie('UserId'),
                    tools.deleteCookie('avatar'),
                    tools.deleteCookie('userName'),
                    tools.deleteCookie('schoolID'),
                    tools.deleteCookie('schoolName'),
                    window.location.href = "//passport.hexfuture.net/#/login/" + encodeURIComponent(window.location.host),
                )
            } else if (XMLHttpRequest.status === 200) {
                //domain报错
                if (data.ErrorCode) {
                    errorF(data.ErrorMessage)
                }
                //接口成功
                else {
                    if (typeof successFunc === "function")
                        successFunc(data);
                }
            } else {
                errorF();
            }
        }
    },

    /**
     * 调用 api
     */
    api: function () {
        // HexConfig.api = "https://api.hexfuture.net/";//发布注释
        const config = apiConfig;
        let apiName = eval('config.' + arguments[0]);
        let ssotokenStr = this.getCookie('localtoken') === null ? '' : '?ssotoken=' + this.getCookie('localtoken');

        //校验token
        // if (ssotokenStr.length > 0) {
        //     let checkToken = this.checkToken();
        //     if (checkToken == false) {
        //         return false;
        //     }
        // }

        let urlVariate = arguments[4] !== undefined ? '/' + arguments[4] : '';
        let reroute_schoolid = "";
        if (ssotokenStr) {
            reroute_schoolid = this.getCookie('reroute_schoolid') === null ? '' : '&reroute_custom_schoolid=' + this.getCookie('reroute_schoolid');
        }
        tools.ajaxRequest(
            HexConfig.api + apiName.split('|')[0] + urlVariate + ssotokenStr + reroute_schoolid,
            apiName.split('|')[1],
            arguments[1],
            arguments[2],
            arguments[3]);
    },

    //校验token
    checkToken: function () {
        let token = this.getCookie('localtoken');
        //校验token
        try {
            if (token && token.length > 0 && window.nowToken && token != window.nowToken) {
                let UserId = this.getCookie("UserId");
                if (UserId && UserId.length > 0 && window.nowUserId && UserId != window.nowUserId) {
                    $('body').append('<div class="hex-network-error"><span class="haveFont">' + "账号已失效，请重新登录！" + '</span></div>');
                    setTimeout(() => {
                        $('div.hex-network-error').remove();
                    }, 2000);
                    this.logout();
                    return false;
                }
            }
        } catch (error) {
            console.log(error);
        }
    },

    logout: function () {
        this.deleteCookie("localtoken");
        this.deleteCookie("UserId");
        this.deleteCookie("avatar");
        this.deleteCookie("userName");
        this.deleteCookie('reroute_schoolid');
        this.deleteCookie('UserId_save');

        setTimeout(function () {
            window.location.reload();
        }, 2000)
    },

    /**
     * 向 LS 存放 json
     * @param key
     * @param json
     */
    setJsonIntoLS: function (key, json) {
        localStorage.setItem(key, JSON.stringify(json))
    },

    /**
     * 从 LS 取出 json
     * @param key
     */
    getJsonFromLS: function (key) {
        return JSON.parse(localStorage.getItem(key));
    },

    /**
     * 克隆一个对象
     * @param obj
     * @returns {*}
     */
    cloneJson: function (obj) {
        return JSON.parse(JSON.stringify(obj))
    },
    /**
     * 根据状态码报错,并且更新token
     */
    throwError: function (Request) {
        try {
            if (Request.responseJSON != null && Request.responseJSON.ErrorCode != undefined && Request.responseJSON.ErrorCode != 0) {
                console.log("错误啦!!!" + "错误代码:" + Request.responseJSON.ErrorCode + "   错误信息:" + Request.responseJSON.ErrorMessage);
                Vue.prototype.$mobile.errorMessage(Request.responseJSON.ErrorMessage);
            } else if (Request.status === 0) {
                Vue.prototype.$mobile.errorMessage('数据请求超时,请检查网络后重新再试。');
            }
        } catch (error) {
            console.log(error);
        }
    },


    //新打开一个页面，href地址，traget是新页面标记
    OpenHref: function (href, target) {
        let a = document.createElement("a");
        a.setAttribute("href", href);
        a.setAttribute("target", target);
        document.body.appendChild(a);

        let e = document.createEvent('MouseEvent');
        e.initEvent('click', false, false);
        setTimeout(a.dispatchEvent(e), 2000);
    },

    /*
     * 获取地址栏问号参数
     */
    $_GET :function () {
        let url = window.document.location.href.toString();
        let u = url.split("?");
        if (typeof (u[1]) == "string") {
            u = u[1].split("&");
            var get = {};
            for (var i in u) {
                var j = u[i].split("=");
                get[j[0]] = j[1];
            }
            return get;
        } else {
            return {};
        }
    },

    //将字符串转换为时间格式,适用各种浏览器,格式如2016-09-09T17:02:37.227"
    GetTimeByTimeStr: function (dateString) {
        let timeArr = dateString.split("T");
        let d = timeArr[0].split("-");
        let t = timeArr[1].split(":");
        return new Date(d[0], d[1] - 1, d[2], t[0], t[1], t[2]);
    },

    //转换时间,试卷转为字符串
    //getMonth()函数的返回值为Number类型，返回当前Date对象的月份值。该值介于 [0, 11] 之间。其中，0 ~ 11 分别表示 1月至12月。超出为0
    Datetimeformat: function (date) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + '/' + m + '/' + d;
    },

    //获取cms图片地址by资源ID
    ConvertResourceUrl: function (resourceId) {
        return this._NewCms + "/FileManage/DownLoadImage?id=" + resourceId;
    },
    //随机生成cms地址
    randomCms: function () {
        let random = parseInt(Math.random() * 5); //生成0-4的正数;

        let cms = "";
        if (random > 0) {
            //cms1001.hexfuture.com--1004
            let cmslist = this._CMShost.split(".");
            cms = cmslist[0] + "100" + random + this._CMShost.split(cmslist[0])[1];
        } else {
            cms = this._CMShost;
        }
        return cms;
    },

    /**
     * loading
     */
    putLoading: function () {
        let loading = "<div class='hex-k12-loading'><div></div></div>";
        $("body").append(loading);
    },

    deleteLoading: function () {
        if ($(".hex-k12-loading")) {
            $(".hex-k12-loading").remove();
        }
    },

    //定义的四种模态框（正确、错误、警告、提示）
    alertyes: function (title, msg, callback) {
        this.alertmodal("success", title, msg, callback);
    },

    alertno: function (title, msg, callback) {
        this.alertmodal("error", title, msg, callback);
    },

    alertwar: function (title, msg, callback) {
        this.alertmodal("waring", title, msg, callback);
    },

    alertconfim: function (title, msg, callback) {
        this.alertmodal("confim", title, msg, callback);
    },

    alertmodal: function (state, title, Msg, callback) {
        $("#MsgModal").remove();

        var html = '';
        html += '<div id="MsgModal" class="hex-cmpnt-Modal">';
        html += '<div style="height:auto;width:auto;" class="K12">';
        html += '<div class="title"><div class="left"></div><div class="right"><a class="close" data-hex-modal-close="#MsgModal"></a></div></div>';
        switch (state) {
            case "success":
                html += '<div class="content"><div class="marktitle"><i class="success"></i><span>' + title + '</span></div>';
                if (Msg) {
                    html += '<div class="text">' + Msg + '</div></div>';
                } else {
                    html += '</div>';
                }
                html += '<div class="button"><button data-hex-modal-close="#MsgModal" class="success hex-normalBtn">好的</button></div>';
                break;
            case "error":
                html += '<div class="content"><div class="marktitle"><i class="error"></i><span>' + title + '</span></div>';
                if (Msg) {
                    html += '<div class="text">' + Msg + '</div></div>';
                } else {
                    html += '</div>';
                }
                html += '<div class="button"><button data-hex-modal-close="#MsgModal" class="error hex-normalBtn">好的</button></div>';
                break;
            case "waring":
                html += '<div class="content"><div class="marktitle"><i class="waring"></i><span>' + title + '</span></div>';
                if (Msg) {
                    html += '<div class="text">' + Msg + '</div></div>';
                } else {
                    html += '</div>';
                }
                html += '<div class="button"><button data-hex-modal-close="#MsgModal" class="success hex-normalBtn">好的</button></div>';
                break;
            case "confim":
                html += '<div class="content"><div class="marktitle"><i class="confim"></i><span>' + title + '</span></div>';
                if (Msg) {
                    html += '<div class="text">' + Msg + '</div></div>';
                } else {
                    html += '</div>';
                }
                html += '<div class="button"><button data-hex-modal-close="#MsgModal" class="cancel hex-normalBtn">取消</button><button id="yep" class="success hex-normalBtn">确定</button></div>';
                break;
            default:
        }
        html += '</div>';
        html += '</div>';
        $("body").append(html);

        $(document.body).off("click", '[data-hex-modal-close="#MsgModal"]');
        if (state === "confim") {
            $(document.body).off("click", '#yep');
            $(document.body).one('click', '#yep', function () {
                $("#MsgModal").fadeOut(500);
                $("body").css("overflow-y", "auto");
                $("#MsgModal").remove();
                if (typeof callback === "function") {
                    callback();
                }
            });
            $(document.body).on('click', '[data-hex-modal-close="#MsgModal"]', function () {
                var who = $(this).attr("data-hex-modal-close").toString();
                $(who).fadeOut(500);
                $("body").css("overflow-y", "auto");
                $("#MsgModal").remove();
            });
        } else {
            $(document.body).on('click', '[data-hex-modal-close="#MsgModal"]', function () {
                var who = $(this).attr("data-hex-modal-close").toString();
                $(who).fadeOut(500);
                $("body").css("overflow-y", "auto");
                $("#MsgModal").remove();
                // clearInterval(setTimeoutModel);
                if (typeof callback === "function") {
                    callback();
                }
            });

            // 1s自动删除
            // let setTimeoutModel = setTimeout(function () {
            //     $("body").css("overflow-y", "auto");
            //     $("#MsgModal").remove();
            //     if (typeof callback == "function") {
            //         callback();
            //     }
            // }, 1500)
        }

        // $("#MsgModal").fadeIn(500);
        $("body").css("overflow-y", "hidden");
    },

    //动态加载样式
    dynamicLoadingCss: function (path) {
        if (!path || path.length === 0) {
            return false;
        }
        var head = document.getElementsByTagName('head')[0];
        var link = document.createElement('link');
        // link.href = path + "?m=1" + parseInt(Math.random() * 100);
        link.href = path;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        head.appendChild(link);
    },

    //动态加载脚本
    dynamicLoadingScript: function (path, callback) {
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        // script.src = path + "?m=1" + parseInt(Math.random() * 100);
        script.src = path;
        script.type = 'text/javascript';
        if (typeof callback === "function") {

            script.onload = function () {

                callback();
            }
        }
        head.appendChild(script);
    },
    //加载MathJax数学编辑器脚本
    GetMathJaxWebsite: function (isload) {
        if ($("[hextype='latex' ]").length > 0 || isload) {
            if (typeof (MathJax) != "undefined") {
                //渲染MathJax公式
                MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
            } else {
                //加载脚本
                tools.dynamicLoadingScript("//static.hexfuture.net/latex/MathJax.js?config=TeX-AMS_HTML", function () {
                    MathJax.Hub.Config({
                        extensions: ["tex2jax.js", "TeX/noUndefined.js"],
                        jax: ["input/TeX", "output/HTML-CSS"],
                        tex2jax: {
                            inlineMath: [["$", "$"], ["\\(", "\\)"]],
                            displayMath: [["$$", "$$"], ["\\[", "\\]"]]
                        },
                        TeX: {extensions: ["AMSmath.js", "AMSsymbols.js"]},
                        "HTML-CSS": {showMathMenu: false},
                        messageStyle: "none",
                    });
                    MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
                });
            }
        }
    },
    /**
     * 放置字体检测
     */
    checkFont:function (dom_targetDiv) {
        let font1Width = 0, font1Height = 0, font2Width = 0, font2Height = 0, font3Width = 0, font3Height = 0,
            font4Width = 0, font4Height = 0;
        let loadFont1Width = 0, loadFont1Height = 0, loadFont2Width = 0, loadFont2Height = 0, loadFont3Width = 0,
            loadFont3Height = 0, loadFont4Width = 0, loadFont4Height = 0;
        let dom_fontLoad1 = document.createElement("span");
        let dom_fontLoad2 = document.createElement("span");
        let dom_fontLoad3 = document.createElement("span");
        let dom_fontLoad4 = document.createElement("span");
        if (document.getElementById('newFontLoad1') === null) {
            dom_fontLoad1.setAttribute('id', 'newFontLoad1')
            dom_fontLoad1.setAttribute('style', 'font-family:SongtiSimpleConvention, SongtiConvention !important');
            dom_fontLoad1.style.color = 'white';
            dom_fontLoad1.style.position = 'fixed';
            dom_fontLoad1.style.visibility = 'hidden';
            dom_fontLoad1.innerText = '啊';
            dom_fontLoad2.setAttribute('id', 'newFontLoad2')
            dom_fontLoad2.setAttribute('style', 'font-family:TimesNewRoman !important');
            dom_fontLoad2.style.color = 'white';
            dom_fontLoad2.style.position = 'fixed';
            dom_fontLoad2.style.visibility = 'hidden';
            dom_fontLoad2.innerText = 'a';
            dom_fontLoad3.setAttribute('id', 'newFontLoad3')
            dom_fontLoad3.setAttribute('style', 'font-family:Symbol !important');
            dom_fontLoad3.style.color = 'white';
            dom_fontLoad3.style.position = 'fixed';
            dom_fontLoad3.style.visibility = 'hidden';
            dom_fontLoad3.innerText = '－';
            dom_fontLoad4.setAttribute('id', 'newFontLoad4')
            dom_fontLoad4.setAttribute('style', 'font-family:SongtiConvention !important');
            dom_fontLoad4.style.color = 'white';
            dom_fontLoad4.style.position = 'fixed';
            dom_fontLoad4.style.visibility = 'hidden';
            dom_fontLoad4.innerText = '＋';
            dom_targetDiv.parentElement.appendChild(dom_fontLoad1);
            dom_targetDiv.parentElement.appendChild(dom_fontLoad2);
            dom_targetDiv.parentElement.appendChild(dom_fontLoad3);
            dom_targetDiv.parentElement.appendChild(dom_fontLoad4);
            let boundingClientRect1 = dom_fontLoad1.getBoundingClientRect();
            let boundingClientRect2 = dom_fontLoad2.getBoundingClientRect();
            let boundingClientRect3 = dom_fontLoad3.getBoundingClientRect();
            let boundingClientRect4 = dom_fontLoad4.getBoundingClientRect();
            font1Width = boundingClientRect1.width;
            font1Height = boundingClientRect1.height;
            font2Width = boundingClientRect2.width;
            font2Height = boundingClientRect2.height;
            font3Width = boundingClientRect3.width;
            font3Height = boundingClientRect3.height;
            font4Width = boundingClientRect4.width;
            font4Height = boundingClientRect4.height;
        }
        try {
            document.fonts.ready.then(function () {
                window.fontIsReady = true;
            });
        } catch (e) {
            let timer = setInterval(function () {
                let boundingClientRect1 = dom_fontLoad1.getBoundingClientRect();
                let boundingClientRect2 = dom_fontLoad2.getBoundingClientRect();
                let boundingClientRect3 = dom_fontLoad3.getBoundingClientRect();
                let boundingClientRect4 = dom_fontLoad4.getBoundingClientRect();
                loadFont1Width = boundingClientRect1.width;
                loadFont1Height = boundingClientRect1.height;
                loadFont2Width = boundingClientRect2.width;
                loadFont2Height = boundingClientRect2.height;
                loadFont3Width = boundingClientRect3.width;
                loadFont3Height = boundingClientRect3.height;
                loadFont4Width = boundingClientRect4.width;
                loadFont4Height = boundingClientRect4.height;
                if ((font1Width !== loadFont1Width || font1Height !== loadFont1Height)
                    && (font2Width !== loadFont2Width || font2Height !== loadFont2Height)
                    && (font3Width !== loadFont3Width || font3Height !== loadFont3Height)
                    && (font4Width !== loadFont4Width || font4Height !== loadFont4Height)) {
                    clearInterval(timer);
                    window.fontIsReady = true;
                }
            })
        }
    },
    //获取latex编辑器
    // GetLatexWebsite: function (callback) {
    //     tools.dynamicLoadingScript(tools._typesetServer + "HexExercise_toHtml.min.js?timestamp=" + new Date().getTime(), callback);
    // },
    //获取相应字体
    GetFonStyle: function (callback) {
        tools.dynamicLoadingScript(tools._typesetServer + "initFont.min.js?timestamp=" + new Date().getTime(), callback);
    },
    //等元素加载到页面上,初始化latex
    initLatex: function (parentNode) {
        let nodes = [];
        // 通过元素的属性值查找对象
        $(parentNode).find("[data-latex]").each(function (e) {
            nodes.push($(this).get(0))
        })
        if (nodes && nodes.length > 0) {
            if (typeof HexExercise == 'undefined') {
                tools.GetLatexWebsite(function () {
                    HexExercise.initLatex({arr_nodes: nodes});
                });
            } else {
                HexExercise.initLatex({arr_nodes: nodes});
            }
        }
    },
    initImg: function (parentNode) {
        let nodes = [];
        // 通过元素的属性值查找对象
        $(parentNode).find('img').each(function (e) {
            nodes.push($(this).get(0))
        })
        if (nodes && nodes.length > 0) {
            if (typeof HexExercise == 'undefined') {
                tools.GetLatexWebsite(function () {
                    HexExercise.initImg(tools.randomCms(), nodes)
                });
            } else {
                HexExercise.initImg(tools.randomCms(), nodes)
            }
        }
    },

    //输入题干片段以及搜索条件
   replaceKeywords:function (htmlString, keyword) {
    if (!keyword) return htmlString
    const div = document.createElement('div')
    div.innerHTML = htmlString
     const textNodes =tools.getTextNodeList(div)
     const textList = tools.getTextInfoList(textNodes)
     const content = textList.map(({ text }) => text).join('')
     const matchList = tools.getMatchList(content, keyword)
     tools.replaceMatchResult(textNodes, textList, matchList)
     return div.innerHTML
  },

   getTextNodeList:function (dom) {
    const nodeList = [...dom.childNodes]
    const textNodes = []
    while (nodeList.length) {
      const node = nodeList.shift()
      if (node.nodeType === node.TEXT_NODE) {
        textNodes.push(node)
      } else {
        nodeList.unshift(...node.childNodes)
      }
    }
    return textNodes
  },


   getTextInfoList:function (textNodes) {
      let length = 0
      const textList = textNodes.map(node => {
        let startIdx = length, endIdx = length + node.wholeText.length
        length = endIdx
        return {
          text: node.wholeText,
          startIdx,
          endIdx
        }
      })
      return textList
    },



    getMatchList:function (content, keyword) {
        const characters = [...'\\[]()?.+*^${}:'].reduce((r, c) => (r[c] = true, r), {})
        keyword = keyword.split('').map(s => characters[s] ? `\\${s}` : s).join('[\\s\\n]*')
        const reg = new RegExp(keyword, 'gmi')
        return [...content.matchAll(reg)] // matchAll结果是个迭代器，用扩展符展开得到数组
    },

    replaceMatchResult:function (textNodes, textList, matchList) {
    //console.log(textNodes,textList,matchList)
        // 对于每一个匹配结果，可能分散在多个标签中，找出这些标签，截取匹配片段并用font标签替换出
        for (let i = matchList.length - 1; i >= 0; i--) {
            const match = matchList[i]
            const matchStart = match.index, matchEnd = matchStart + match[0].length // 匹配结果在拼接字符串中的起止索引
            // 遍历文本信息列表，查找匹配的文本节点
            for (let textIdx = 0; textIdx < textList.length; textIdx++) {
            const { text, startIdx, endIdx } = textList[textIdx] // 文本内容、文本在拼接串中开始、结束索引
            if (endIdx < matchStart) continue // 匹配的文本节点还在后面
            if (startIdx >= matchEnd) break // 匹配文本节点已经处理完了
            let textNode = textNodes[textIdx] // 这个节点中的部分或全部内容匹配到了关键词，将匹配部分截取出来进行替换
            const nodeMatchStartIdx = Math.max(0, matchStart - startIdx) // 匹配内容在文本节点内容中的开始索引
            const nodeMatchLength = Math.min(endIdx, matchEnd) - startIdx - nodeMatchStartIdx // 文本节点内容匹配关键词的长度
            if (nodeMatchStartIdx > 0) textNode = textNode.splitText(nodeMatchStartIdx) // textNode取后半部分
            if (nodeMatchLength < textNode.wholeText.length) textNode.splitText(nodeMatchLength)
            const font = document.createElement('label')
            font.setAttribute("style","color:red")
            font.innerText = text.substr(nodeMatchStartIdx, nodeMatchLength)
            textNode.parentNode.replaceChild(font, textNode)
            }
        }
        }
    }

export default tools;
